import {
  createMainSection,
  createSubSection,
  deleteMainSection,
  deleteSubSection,
  isValidOrderNumber,
  saveEditedMainSection,
  saveEditedSection,
} from './create_sections_section_crud_helpers.js';

export const create_sections_section_crud_methods = {
  async create_main_section() {
    this.main_section_name_error = !this.resolve_main_section_name();
    this.order_number_error = !isValidOrderNumber(this.new_main_section.order_number);
    if (this.main_section_name_error || this.order_number_error) return;
    await createMainSection(this);
  },

  async create_sub_section() {
    this.sub_section_name_error = !this.resolve_sub_section_name();
    this.order_number_error = !isValidOrderNumber(this.new_sub_section.order_number);
    if (this.sub_section_name_error || this.order_number_error) return;
    await createSubSection(this);
  },

  async save_edited_section() {
    this.edit_section_name_error = !String(this.current_edit_section.name || '').trim();
    if (this.edit_section_name_error) return;
    await saveEditedSection(this);
  },

  async save_edited_main_section() {
    this.edit_main_section_name_error = !String(this.current_edit_main_section.main_section_name || '').trim();
    if (this.edit_main_section_name_error) return;
    await saveEditedMainSection(this);
  },

  delete_sub_section(section = {}) {
    deleteSubSection(this, section);
  },

  delete_main_section(main_section = {}) {
    deleteMainSection(this, main_section);
  },
};
